import React, {Component} from 'react';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom'
import App from './App';
import NoMatch from './pages/NoMatch';
import Home from './pages/Home';
import Shop from './pages/Shop';
import Locator from './pages/Locator';
import Tour from './pages/Tour';
import Recipes from './pages/Recipes';
import About from './pages/About';
import History from './pages/History';
import Contact from './pages/Contact';
import Nutrition from './pages/Nutrition';
import Storage from './pages/Storage';
import RefundsCancellations from './pages/RefundsCancellations';
import FAQ from './pages/FAQ';
import Sitemap from './pages/Sitemap';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import axios from 'axios';
import scrollToElement from 'scroll-to-element';

const loadScript = require('simple-load-script');

export default class Routes extends Component {
  //static propTypes = {testProp: PropTypes.bool.isRequired}

  constructor(props) {
    super(props);

    this.state = {
      windowWidth: 0,
      products: [],
      googleMapsLoaded: false,
      googleMapsObject: null,
      cartItemCount: 0,
      cartPriceTotal: 0,
      user: null,
      userLoggedIn: false,
      previousRoute: {},
      currentRoute: {},
      homeIsMounted: false

    };
  }
  
  
  setHomeIsMounted = () => { this.setState({ homeIsMounted: !this.state.homeIsMounted }) }
  setPreviousRoute = (previousRoute) => { this.setState({ previousRoute }) }
  setCurrentRoute = (currentRoute) => { this.setState({ currentRoute }) }

  componentDidMount() {
    this.loadSnipcartJQuery();
    this.loadGoogleMaps();
    this.setProductsState();
    window.onresize = () => this.setWindowWidth();
    this.setWindowWidth();
  }
  componentWillUnmount() {
    window.onresize = null;
  }

  setDefaultCartStateValues = () => {
    let cartItemCount = 0;
    let cartPriceTotal = 0;
    let user = null;
    let userLoggedIn = false;

    try {
      window.Snipcart.api.items.all().map((item, index) => {
        cartPriceTotal += (item.price * item.quantity);
        cartItemCount += item.quantity;
      });

      user = window.Snipcart.api.user.current();
      if(typeof(user) !== "undefined" && user !== null) { userLoggedIn = true; }
        else { userLoggedIn = false;}

      this.setCartItemCount(cartItemCount);
      this.setCartPriceTotal(cartPriceTotal);
      this.setUser(user);
      this.setUserLoggedIn(userLoggedIn);
    }
    catch(err) {
      console.log("Error accessing Snipcart API");
    }

  }

  addItemToCartState = (quantityToAdd, totalToAdd) => {
    this.setState({
      cartItemCount: this.state.cartItemCount + quantityToAdd,
      cartPriceTotal: this.state.cartPriceTotal + totalToAdd
    });
  }

  setCartItemCount = (cartItemCount) => { this.setState({ cartItemCount }); }
  setCartPriceTotal = (cartPriceTotal) => { this.setState({ cartPriceTotal }); }
  setUser = (user) => { this.setState({ user }); }
  setUserLoggedIn = (userLoggedIn) => { this.setState({ userLoggedIn }); }

  logoutClick = () => { this.eventFire(document.getElementById("logoutMock"), 'click'); this.setDefaultCartStateValues(); }
  loginClick = () => { this.eventFire(document.getElementById("loginMock"), 'click'); }
  loggedInEmailClick = () => { this.eventFire(document.getElementById("loginMock"), 'click'); }

  setProductsState = () => {
    axios.get('https://s3.amazonaws.com/pattersonmaplefarmsstorage/products/info/Products.json')
      .then(response => {
        this.setState({
          products: response.data
        });
        
      })
      .catch(error => {
        console.log('Error fetching and parsing data', error);
      });
  }

  validatePhone = (value) => { return value.match(/^[\d-()]{7,}$/g); }
  validateZip = (value) => { return value.match(/^[\d]{5,}$/g); }

  snipcartScriptLoaded = () => {
    window.Snipcart.api
    .configure("show_continue_shopping", true)
    .configure('credit_cards', [
      {'type': 'visa', 'display': 'Visa'},
      {'type': 'mastercard', 'display': 'Mastercard'},
      {'type': 'discover', 'display': 'Discover'}
    ])

    

    window.Snipcart.execute("registerLocale", "en", {
      "my_cart": "My Bucket",
      "cart_empty_text": "Your bucket is empty. Select some products to buy before checking out. ",
      "bill_me_later_action": "Invoice Billing",
      "bill_me_later": "Invoice Billing",
      "payment_informations_bill_me_later": "Invoice Billing - invoice will be sent.",
      "total": "Total: (You may receive a partial refund within a max of 3-5 business days if we can get actual shipping costs to be less than the amount above. Thank you!)"
    })

    window.Snipcart.subscribe('page.validating', (ev, data) => {
      if(ev.type == 'shipping-address' || ev.type == 'billing-address') {
        this.validatePhone(data.phone) ? "" : ev.addError('phone', 'Please enter a phone number between 7 and 19 digits.');

        // If they're from Hawaii, out of US, or enter a zip with anything but digits, tell them to call to place their order.
        if(data.province.toUpperCase() == "HI" ) { ev.addError('postalCode', 'You are outside the continental US. Please call us to place your order. We will give you personal attention. Thank you!') }
        if(data.country != "US") { ev.addError('postalCode', 'You are outside the continental US. Please call us to place your order. We will give you personal attention. Thank you!') }
        if(!this.validateZip(data.postalCode)) { ev.addError('postalCode', 'Your digit must contain only digits. If it truly contains letters, please call us to place your order. We will give you personal attention. Thank you!') }
        console.log(data);
      }
    })

    document.addEventListener("snipcart.ready", () => {
      this.setDefaultCartStateValues();
    }, false);
    
    // If the cart is closed, call this.

    /*
    if(typeof(window.Snipcart) !== "undefined"){// && typeof(snipcart.api.items) !== "undefined") {
      try {
        //if(typeof(snipcart.api.items.all()[0]) !== "undefined") {
          this.setDefaultCartStateValues();
        //}
      }
      // Just throw it on initial call where snipcart.api.items.all() is undefined. It doesn't matter.
      catch(err) {}
    }
    */
  }

  loadSnipcartJQuery = () => {
    const jquery = "https://ajax.googleapis.com/ajax/libs/jquery/2.2.2/jquery.min.js";
    const snipcart = "https://cdn.snipcart.com/scripts/2.0/snipcart.js";
    let jqueryLoaded = this.isScriptLoaded(jquery);
    let snipcartLoaded = this.isScriptLoaded(snipcart);

    // Load JQuery
    if(!jqueryLoaded) {
      loadScript(jquery)

        // Use JQuery script
        .then( (script) => {

          // Then load Snipcart
          if(!snipcartLoaded) {

            loadScript({
              url: snipcart, 
              attrs: {id: "snipcart", "data-api-key": "M2M2ZWJkYzEtZDZhMi00ZTM0LWI5MDMtNzliZjJlNjM0ZDgzNjM2NTA4NzQ1NDU2MDgzMDU3", 
                      "data-autopop": false,
                      "show-continue-shopping": true
                       } 
                    })

            // Use snipcart script
            .then( (script) => {  
              this.snipcartScriptLoaded();
            })
            .catch( (err) => {
              console.log(`Snipcart load error: ${err}`);
            })
          }

        })
        .catch( (err) => {
          console.log(`JQuery load error: ${err}`);
        })
    }
  }

  loadGoogleMaps = () => {
    const googleMaps = "https://maps.googleapis.com/maps/api/js?key=AIzaSyDrhMCap4BXT3M3hmtrEc0I7fDM8CkCmSs";
    let googleMapsLoaded = this.isScriptLoaded(googleMaps);

    if(!googleMapsLoaded) {
      loadScript({
        url: googleMaps
      })
      .then( (script) => {
        this.setState({
          googleMapsLoaded: true,
          googleMapsObject: window.google.maps
        });
      })
      .catch( (err) => {
        console.log(`GoogleMaps load error: ${err}`);
      })
    }
  }

  isScriptLoaded = (script) => {
    const scripts = document.getElementsByTagName('script');
      for (var i = scripts.length; i--;) {
          if (scripts[i].src == script) 
          {
            return true;
          }
      }

      return false;
  }

  scrollToSection = (idToScrollTo, offsetNum) => {
    let navigateTo = document.querySelector("#" + idToScrollTo);

    scrollToElement(navigateTo, {
      offset: offsetNum,
      align: "top",
      duration: 1000
    });
  }

  eventFire = (el, etype) => {
    if (el.fireEvent) {
      el.fireEvent('on' + etype);
    } else {
      var evObj = document.createEvent('Events');
      evObj.initEvent(etype, true, false);
      el.dispatchEvent(evObj);
    }
  }

  setWindowWidth = () => { this.setState({ windowWidth: window.innerWidth });  }

  render() {
    //const ExampleObject = ( <div></div> );

    return (
		<BrowserRouter>
				<App  cartItemCount={this.state.cartItemCount} cartPriceTotal= {this.state.cartPriceTotal} user={this.state.user} userLoggedIn={this.state.userLoggedIn}
              setCartItemCount={this.setCartItemCount} setCartPriceTotal={this.setCartPriceTotal} setUser={this.setUser} setUserLoggedIn={this.setUserLoggedIn}
              logoutClick={this.logoutClick} loginClick={this.loginClick} loggedInEmailClick={this.loggedInEmailClick} 
              setDefaultCartStateValues={this.setDefaultCartStateValues}
              setPreviousRoute={this.setPreviousRoute} setCurrentRoute={this.setCurrentRoute}
              previousRoute={this.state.previousRoute} currentRoute={this.state.currentRoute}
              homeIsMounted={this.state.homeIsMounted} scrollToSection={this.scrollToSection} >
					<Switch>

						<Route path='/Shop/:initialFilter?' header="Shop" 
							render={(props) => ( <div>
                { this.state.products.length > 0 ? <Shop products={this.state.products} windowWidth={this.state.windowWidth} 
                                                         scrollToSection={this.scrollToSection} addItemToCartState={this.addItemToCartState}
                                                         cartItemCount={this.state.cartItemCount} /> : "" } 
                </div> ) } />
						<Route path='/Locator' header="Locator"
              render={(props) => ( <div>
                { this.state.googleMapsLoaded ? <Locator googleMapsObject={this.state.googleMapsObject} googleMapsLoaded={this.state.googleMapsLoaded} /> : "" }
                </div> ) } />
						<Route path='/Tour' header="Tour" render={(props) => ( <div> { this.state.googleMapsLoaded ? <Tour /> : "" } </div> ) } />
						<Route path='/Recipes' header="Recipes" render={(props) => ( <div> { <Recipes /> } </div> ) } />
						<Route path='/History' header="History" component={History} />
						<Route path='/Contact' header="Contact" component={Contact} />
						<Route path='/Nutrition' header="Nutrition" component={Nutrition} />
						<Route path='/Storage' header="Storage" component={Storage} />
						<Route path='/RefundsCancellations' header="RefundsCancellations" component={RefundsCancellations} />
						<Route path='/FAQ' header="FAQ" component={FAQ} />
            <Route path='/Privacy' header="Privacy" component={Privacy} />
            <Route path='/Terms' header="Terms" component={Terms} />
            <Route path='/Sitemap' header="Sitemap" component={Sitemap} />

            <Route exact path='/:scrollToSection?' header="Home" 
              render={(props) => ( <Home products={this.state.products} scrollToSection={this.scrollToSection} 
                setHomeIsMounted={this.setHomeIsMounted} windowWidth={this.state.windowWidth} /> ) } />

						<Route path='empty' key="empty" component={null} />
						<Route path='/404' header="404" component={NoMatch} />
						
						<Redirect to="/404" />
					</Switch>
				</App>
		</BrowserRouter>	

		);
	}
}



// WEBPACK FOOTER //
// ./src/Routes.js